<router-outlet></router-outlet>
<switch-overlay></switch-overlay>
